import * as types from './DateTime.types';

export const setGlobalDateTime = (data) => ({
  type: types.SET_GLOBAL_DATETIME,
  data,
});
